<main class="main-wrap">
  <div class="wrapper">
    <div class="skin-boxes-main">
      <div class="skin-logo">
        <a href="#"><img src="assets/images/logo-w-tagline.svg"></a>
      </div>
      <div class="sk-BoxWrap">
        <div class="item active">
          <div class="itemWrap">
            <div class="sk-text">"I don’t know my <span class="outline-txt">SKIN TYPE</span> and <span
                class="outline-txt">concerns</span></div>
            <div class="sk-btn">
              <a href="#" class="cta-button">take our skin test</a>
            </div>
          </div>
        </div>
        <div class="item">
          <div class="itemWrap">
            <div class="sk-text">"I need a <span class="outline-txt">DOCTOR</span> for <span class="outline-txt">my
                skin</span></div>
            <div class="sk-btn">
              <a href="skin-consultation" class="cta-button">skin consultation</a>
            </div>
          </div>
        </div>
        <div class="item">
          <div class="itemWrap">
            <div class="sk-text">“I KNOW <br>what i <span class="outline-txt">want”</span></div>
            <div class="sk-btn sk-2">
              <a href="home-page" class="cta-button">skincare store</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</main>